module.exports = __webpack_public_path__ + "7b5930f057675ebc2dbd524cf50de748.svg";